export function getUserTypeByWindowHref() {
  var userType = 0; //0一般管理员用户(13312341234/123456)；1专员管理(18812341234/123456)；2外部用户(13812345678/123456)
  if (window.location.href.indexOf('admin') !== -1) {
    userType = 1;
  }
  if (window.location.href.indexOf('super') !== -1) {
    userType = 2;
  }
  return userType;
}
export function getFirstRouterPath(url) {
  var path = "/";
  var user_type = getUserTypeByWindowHref();
  if (user_type == 0) {
    path = '/mission';
  } else if (user_type == 1) {
    path = '/commissioner';
  } else if (user_type == 2) {
    path = '/taskDashBoard';
  }
  return path;
}